import { Box } from "@bcc-ui/ui-components";
import React from "react";

import style from "./ai-getting-started-button.scss";

interface Props {
    children: React.ReactNode;
    icon: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    testId: string;
}

export const AIGettingStartedButton = (props: Props) => {
    return (
        <Box
            columnLayout
            paddingTop={"Sm"}
            paddingBottom={"Xxs"}
            paddingLeft={"Sm"}
            paddingRight={"Sm"}
            className={props.disabled ? style.disabled : style.button}
            onClick={props.disabled ? undefined : props.onClick}
            testId={props.testId}
        >
            <span className={style.icon}>{props.icon}</span>
            <span className={style.buttonText}>{props.children}</span>
        </Box>
    );
};
